import type { AxiosInstance } from "axios";

import { Actioner, GTMActionKeys } from "@services/actioner";

import { createMRTMAuthAdapter } from "./mrtm-auth-adapter";
import { createMRTMCampaignsAdapter } from "./mrtm-campaigns-adapter";
import { createMRTMOnboardingAdapter } from "./mrtm-onboarding-adapter";
import { createMRTMPaymentAdapter } from "./mrtm-payment-adapter";
import { createMRTMPortingAdapter } from "./mrtm-porting-adapter";
import { createMRTMProductsAdapter } from "./mrtm-products-adapter";

export const createMRTMAdapter = ({
	httpClient,
}: {
	httpClient: AxiosInstance;
}) => {
	httpClient.interceptors.response.use(
		(response) => response,
		async (error) => {
			if (
				!error.response ||
				error?.response?.status === 408 ||
				error.code === "ECONNABORTED"
			) {
				Actioner.trigger(GTMActionKeys.REQUEST_TIMEOUT);

				const isPromoCodeRequest = error.config?.url?.includes("/campaigns");

				if (!isPromoCodeRequest && typeof window !== "undefined") {
					setTimeout(() => window.location.replace("/404"), 1000);
				}

				return Promise.reject(error);
			}

			return Promise.reject(error);
		},
	);

	return {
		auth: createMRTMAuthAdapter(httpClient),
		campaigns: createMRTMCampaignsAdapter(httpClient),
		onboarding: createMRTMOnboardingAdapter(httpClient),
		payment: createMRTMPaymentAdapter(httpClient),
		porting: createMRTMPortingAdapter(httpClient),
		products: createMRTMProductsAdapter(httpClient),
	};
};
